var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlans(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "29px",
    height: "21px",
    viewBox: "0 0 29 21",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "[[D]]-Business",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Settings-Plan-selection",
    transform: "translate(-22.000000, -185.000000)",
    fill: "#1C363C"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Functions",
    transform: "translate(0.000000, 99.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 2,
    transform: "translate(13.000000, 73.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/Card",
    transform: "translate(0.500025, 0.500000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.6127429,20 L34.3872571,20 L34.3872571,19 L11.6127429,19 L11.6127429,20 Z M11.6127429,22 L11.6127429,29.6412716 C11.6127429,30.1748712 12.057372,30.6079376 12.6026932,30.6079376 L33.3984382,30.6079376 C33.9448907,30.6079376 34.3872571,30.1748712 34.3872571,29.6412716 L34.3872571,22 L11.6127429,22 Z M11.6127429,17 L34.3872571,17 L34.3872571,16.3565189 C34.3872571,15.824024 33.9448907,15.3920624 33.3984382,15.3920624 L12.6026932,15.3920624 C12.057372,15.3920624 11.6127429,15.824024 11.6127429,16.3565189 L11.6127429,17 Z M34.62892,33 L11.3723452,33 C10.0640759,33 9,31.9336207 9,30.6225195 L9,15.3749445 C9,14.0651113 10.0640759,13 11.3723452,13 L34.62892,13 C35.9359241,13 37,14.0651113 37,15.3749445 L37,30.6225195 C37,31.9336207 35.9359241,33 34.62892,33 Z M19.2941176,28 L14.7058824,28 C14.3162353,28 14,27.7673448 14,27.4783516 L14,24.5216484 C14,24.2336985 14.3162353,24 14.7058824,24 L19.2941176,24 C19.6837647,24 20,24.2336985 20,24.5216484 L20,27.4783516 C20,27.7673448 19.6837647,28 19.2941176,28 Z",
    id: "Combined-Shape"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlans);
export default __webpack_public_path__ + "static/media/plans.b0058418551cc500cbe869cb1b3c5989.svg";
export { ForwardRef as ReactComponent };